module.exports = __webpack_public_path__ + "img/menu-parallax.542f3b06.jpg";